import { useState } from 'react';
import { Star, ExternalLink } from 'lucide-react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';

const reviews = [
  {
    id: 1,
    author: "manan vaid",
    rating: 5,
    date: "2 days ago",
    text: "Best pita bread you can buy for yourself and your family. Once you try them you'll never go back to store bought bread. Anubhuti Ji (Head Baker) is a delightful person to speak with and coordinate delivery. Literally took payment the night before and delivered fresh bread next day on time. She's also very knowledgeable in her craft (offered to research and prepare a specific type of bread that wasn't being sold by them). 10/10 will buy from here again!",
    location: "Gurugram"
  },
  {
    id: 2,
    author: "misha",
    rating: 5,
    date: "6 weeks ago",
    text: "Thank you so much for the cake pops! they were a delight everyone loved them. They tasted and looked great.",
    location: "Gurugram"
  },
  {
    id: 3,
    author: "Shikha Sayal",
    rating: 5,
    date: "9 weeks ago",
    text: "Just wanted to say thank you for the cake — everyone absolutely loved it!😀",
    location: "Gurugram"
  },
  {
    id: 4,
    author: "Nishi Sharma",
    rating: 5,
    date: "10 weeks ago",
    text: "Ordered the birthday cake for our daughter. It was a pleasant experience to interact with Anubhuti for design discussion - perfect combination of professionalism with a touch of personalised connect. The cake was very nice, delicious and was appreciated by everyone. Thanks @House of breads team.",
    location: "Gurugram"
  },
  {
    id: 5,
    author: "Sargam Malhotra",
    rating: 5,
    date: "11 weeks ago",
    text: "We ordered Mickey mouse themed chocolate truffle. The taste was great and the cake was nicely designed. Timely delivery as well.. thank you!",
    location: "Gurugram"
  },
  {
    id: 6,
    author: "Kavita Arvind",
    rating: 5,
    date: "14 weeks ago",
    text: "First of all Anu thank u so much for the very last minute order and executing it so beautifully. The kids & adults loved the cake. It was a beautiful looking cake with smooth chocolate mousse & tangy orange filling. It was simply delicious.Thanks again for accommodating and delivering before time.you are a saviour..love u",
    location: "Gurugram"
  },
  {
    id: 7,
    author: "Megha Jain",
    rating: 5,
    date: "2 months ago",
    text: "Thanks dear Anubhuti for the delicious and yummy cake. My daughter loved it. The surprise in the centre of the cake is outstanding and not only kids we being elders also enjoyed it. Thank you so much :) :) :). I would love to order more cakes from you.",
    location: "Gurugram"
  },
  {
    id: 8,
    author: "Priya Sharma",
    rating: 5,
    date: "1 month ago",
    text: "Absolutely loved the fresh bread and cookies! Everything is eggless and tastes amazing. The sourdough is the best I've had in Gurugram. Highly recommend!",
    location: "Gurugram"
  },
  {
    id: 9,
    author: "Rajesh Kumar",
    rating: 5,
    date: "3 weeks ago",
    text: "Ordered a customized theme cake for my son's birthday. The design was exactly what we wanted and it tasted incredible. Great service and timely delivery!",
    location: "Gurugram"
  },
  {
    id: 10,
    author: "Anita Verma",
    rating: 5,
    date: "2 weeks ago",
    text: "The tea cakes are my favorite! Perfect with evening chai. All products are fresh and made with high quality ingredients. Worth every penny.",
    location: "Gurugram"
  },
  {
    id: 11,
    author: "Vikram Singh",
    rating: 5,
    date: "1 week ago",
    text: "Best eggless bakery in Gurugram! The gift hampers are beautifully packaged and perfect for corporate gifting. Everyone in our office loved them.",
    location: "Gurugram"
  }
];

const StarRating = ({ rating }) => {
  return (
    <div className="flex items-center gap-1">
      {[1, 2, 3, 4, 5].map((star) => (
        <Star
          key={star}
          className={`h-4 w-4 ${
            star <= rating ? 'fill-amber-400 text-amber-400' : 'text-gray-300'
          }`}
        />
      ))}
    </div>
  );
};

export const ReviewsModal = ({ open, onOpenChange }) => {
  const averageRating = (reviews.reduce((acc, r) => acc + r.rating, 0) / reviews.length).toFixed(1);
  const totalReviews = reviews.length;

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-3xl max-h-[80vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle className="text-2xl font-bold text-accent">
            Customer Reviews
          </DialogTitle>
        </DialogHeader>

        <div className="space-y-6">
          <div className="flex items-center justify-between bg-amber-50 rounded-xl p-6">
            <div>
              <div className="flex items-center gap-3 mb-2">
                <span className="text-4xl font-bold text-primary">{averageRating}</span>
                <div>
                  <StarRating rating={5} />
                  <p className="text-sm text-muted-foreground mt-1">
                    Based on {totalReviews} reviews
                  </p>
                </div>
              </div>
            </div>
            <a
              href="https://www.google.com/search?q=Hhouse+of+Breadss+-+Where+Baking+Becomes+Art&stick=H4sIAAAAAAAA_-NgU1I1qDC2NEgxMk5NMTNMNbBMSja0MqiwSE01sDCzNDZMMzU0T002WcSq45GRX1qcqpCfpuBUlJqYUlysoKsQnpFalKrglJidmZeu4JSanJ-bWqzgWFQCAL2NdlNYAAAA&hl=en-GB&mat=CUnj2T82iYyqElcBTVDHnhzH3qUTvfB_BJ3yVrpFkcfRfwgsU1vQcfi9It3-Q6k-rO82s9WBJNZHZCmZ1RSlPBD1ExFc_1Zke7eUNMjqEL3edajdBfrrkYQpoQStXnpCCDM&authuser=0"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-2 text-primary hover:text-primary/80 transition-colors"
              data-testid="view-on-google-link"
            >
              <span className="text-sm font-medium">View on Google</span>
              <ExternalLink className="h-4 w-4" />
            </a>
          </div>

          <div className="space-y-4">
            {reviews.map((review) => (
              <div
                key={review.id}
                className="border border-amber-100 rounded-xl p-6 hover:shadow-md transition-shadow"
              >
                <div className="flex items-start justify-between mb-3">
                  <div>
                    <h3 className="font-semibold text-accent">{review.author}</h3>
                    <p className="text-xs text-muted-foreground">
                      {review.location} · {review.date}
                    </p>
                  </div>
                  <StarRating rating={review.rating} />
                </div>
                <p className="text-muted-foreground leading-relaxed">{review.text}</p>
              </div>
            ))}
          </div>

          <div className="pt-4 border-t border-amber-100 text-center">
            <p className="text-sm text-muted-foreground mb-4">
              Share your experience with us!
            </p>
            <a
              href="https://g.page/r/CcR-UR-ThuCOEAE/review"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="write-review-link"
            >
              <Button className="rounded-full bg-primary hover:bg-primary/90">
                Write a Review
              </Button>
            </a>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export const FloatingReviewButton = ({ onClick }) => {
  return (
    <button
      onClick={onClick}
      className="fixed bottom-6 right-6 z-[9999] bg-primary text-white rounded-full p-4 shadow-2xl hover:scale-110 transition-all duration-300 group"
      data-testid="floating-review-button"
    >
      <div className="flex items-center gap-2">
        <Star className="h-6 w-6 fill-current" />
        <span className="font-semibold hidden sm:inline">Reviews</span>
      </div>
      <Badge className="absolute -top-2 -right-2 bg-success text-white px-2 py-1">
        5.0
      </Badge>
    </button>
  );
};
